module.exports = __webpack_public_path__ + "img/job.b6da1ffe.svg";